import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { ProductWithNoRecipeRow } from "../models/ProductsWithNoRecipe";

export const getProductsWithNoRecipe = async ({
	signal,
}: {
	signal?: AbortSignal;
} = {}): Promise<ProductWithNoRecipeRow[]> => {
	const apiService = new MESApiService();
	const spName = "[MILL].[GetProductsWithoutRecipeDataWeb]";
	const resp = await apiService.callV2(spName, [], signal);
	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching products without recipe");
	}
	return get(resp, "data.tables[0].rows", []) as ProductWithNoRecipeRow[];
};
